export default __webpack_public_path__ + "c563aebfcb76653464c88a51695c8aea.png";